/* global Conf */
import AWS from 'aws-sdk'
import Evaporate from 'evaporate'

export default class AwsService {
  constructor (requester) {
    this.requester = requester
  }

  _evaporate = null

  encode (data) {
    var str = data.reduce(function (a, b) {
      return a + String.fromCharCode(b)
    }, '')
    return btoa(str).replace(/.{76}(?=.)/g, '$&\n')
  }

  getInfo (key) {
    return this.requester.call(`/service/s3/info?key=${key}`).then(res => res.data)
  }

  remove (key) {
    return this.requester.call(`/service/s3/delete?key=${key}`)
  }

  _createEvaporate () {
    return new Promise((resolve, reject) => {
      // if (this._evaporate) {
      //   return resolve(this._evaporate)
      // }
      const config = {
        signerUrl: Conf.url + '/uploads/signer',
        logging: false,
        aws_key: Conf.aws_key,
        bucket: Conf.aws_bucket,
        maxConcurrentParts: 4,
        partSize: 16 * 1024 * 1024, // 16MB
        cloudfront: true,
        computeContentMd5: true,
        cryptoMd5Method: function (data) {
          return data && AWS.util.crypto.md5(data, 'base64')
        },
        cryptoHexEncodedHash256: function (data) {
          return AWS.util.crypto.sha256(data, 'hex')
        },
        signHeaders: this.requester.authHeaders
      }
      Evaporate.create(config).then(resolve).catch(reject)
    })
  }

  cancel () {
    const _del = (err) => {
      delete this._evaporate
      err && console.log('Cancel:', err)
    }
    if (this._evaporate) {
      return this._evaporate.cancel().then(_del).catch(_del)
    }
  }

  upload (s3_path, file, upload, progressCb) {
    return new Promise((resolve, reject) => {
      this._createEvaporate().then(evaporate => {
        this._evaporate = evaporate
        const addConfig = {
          name: s3_path,
          file: file,
          progress: progressCb
        }
        evaporate.add(addConfig).then(awsObjectKey => {
          upload.awsObjectKey = awsObjectKey // store what S3 returned ..
          this.getInfo(awsObjectKey).then(info => { // verify the stored file is complete
            console.log(`S3:${JSON.stringify(info, null, 4)}`)
            console.log(`upload:${JSON.stringify(upload, null, 4)}`)
            if (info.ContentLength === upload.final_length) {
              console.log('resolving ...')
              resolve(upload)
            } else {
              console.log('rejecting ...')
              const p = this.cancel()
              p ? p.then(() => reject('Unexpected end of input')) : reject('Unexpected end of input')
            }
          }).catch(reject)
        }, (err) => {
          reject(err)
        }).catch(reject)
      }).catch(reject)
    })
  }
}
